'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function sumSerializerSizes(sizes) {
  return sizes.reduce((all, size) => all === null || size === null ? null : all + size, 0);
}

exports.sumSerializerSizes = sumSerializerSizes;
//# sourceMappingURL=sumSerializerSizes.cjs.map
